// extracted by mini-css-extract-plugin
export default {"footer":"StepsFooter-module__footer--XOmaX","step":"StepsFooter-module__step--IhyDv","active":"StepsFooter-module__active--dV4t4"};